import { useEffect, useRef } from 'react'

function useInactivity(timeoutDuration: number, onTimeout: () => void) {
	const timeoutIdRef = useRef<ReturnType<typeof setTimeout> | null>(null)

	useEffect(() => {
		const resetTimer = () => {
			if (timeoutIdRef.current) {
				clearTimeout(timeoutIdRef.current)
			}
			timeoutIdRef.current = setTimeout(() => {
				onTimeout()
			}, timeoutDuration)
		}

		const events = ['click', 'mousemove', 'keydown', 'scroll', 'touchstart']
		events.forEach((event) => window.addEventListener(event, resetTimer))

		// Initialize the timer once on mount
		resetTimer()

		return () => {
			events.forEach((event) => window.removeEventListener(event, resetTimer))
			if (timeoutIdRef.current) {
				clearTimeout(timeoutIdRef.current)
			}
		}
	}, [timeoutDuration, onTimeout])
}

export default useInactivity
